// Misma razon que /privacidad: el layout raiz apaga el SSR (la app es una SPA),
// y Google Play revisa esta URL desde afuera. Si la leyera sin ejecutar
// JavaScript veria una pagina en blanco. Aca se reactiva el SSR solo para esta
// ruta, asi el HTML servido trae el texto completo.
export const ssr = true;
export const prerender = true;
